import React from 'react';
import { ScrollView } from 'react-native';
import Header from '../Header/Header.web';
import Section from '../sections/Section';
import Footer from '../footer/Footer';

function StaticPage(props) {
  return (
    <ScrollView>
      <Header />
      <Section>{props.children}</Section>
      <Footer />
    </ScrollView>
  );
}

export default StaticPage;
